export const selectUserGoals = (state) => state.goals.userGoals
export const selectViewGoalsLoading = (state) => state.goals.viewGoalsLoading
export const selectNoGoalsFound = (state) => state.goals.noGoalsFound
export const selectCreateGoalLoading = (state) => state.goals.createGoalLoading



// WEBPACK FOOTER //
// ./src/services/goals/selectors.js